module.exports = __webpack_public_path__ + "7d088296/img/delete-icon.eb7de062.svg";